<div class="ai-tag-bg">
    <span title="{{name}}" class="ai-tag" [style.background-color]="color| addAlpha" [style.color]="darken(color)" >
        {{name}} {{ boundingboxNum !== undefined ? "(" + boundingboxNum + ")" : "" }}
        <i *ngIf="isDeletable" class="icon icon-times" style="cursor: pointer;" (click)="this.onDeletion.emit();" [ngbTooltip]="'Remove label from image.'" [placement]="'top'" ></i>
    </span>
</div>
